import React from 'react';
import { DefinitionBlock, Heading } from '../../util/typography';
import PropTypes from 'prop-types';
import ComponentWrapper from '../layout/ComponentWrapper';
import styled from 'styled-components';
import { createMarkup } from '../../util/functions';
import * as Text from '../../util/typography/Text';
import * as colors from '../../util/colors';


const PrimaryClaimTitle = styled(Heading.H2)`
    text-align: center;
`;

const PrimaryClaimTitleCustom = styled(Heading.H3)`
    text-align: center;
`;

const Definition = styled(Text.Footnote)`
color: ${colors.white};
margin-top: 10px;
`;

const Heading1 = styled(Text.Eyebrow)`
color: ${colors.white};
margin-bottom: 10px;
`;

const ContentWrapper = styled.div`
text-align: center;`;


const PrimaryClaim = ({ theme, heading, children, definitions, shortHead }) => {
    return (
        (!heading)
        ?
        <ComponentWrapper>
            {shortHead && <ContentWrapper>
                <Heading1 dangerouslySetInnerHTML={createMarkup(shortHead)} />
            </ContentWrapper>}
            
            <PrimaryClaimTitle theme={theme} dangerouslySetInnerHTML={createMarkup(children)} />
        </ComponentWrapper>
        :
        <ComponentWrapper>
            <PrimaryClaimTitleCustom theme={theme} dangerouslySetInnerHTML={createMarkup(children)} />
        </ComponentWrapper>
    );
};

PrimaryClaim.propTypes = {
    /**
     * This is the primary indication; Currently a string, but probably needs a shape matches the more complex use case. Needs to support at least superscript notations.
     */
    children: PropTypes.string,
};

export default PrimaryClaim;
